import { InjectionToken } from "@angular/core";
import { PageTemplate } from "../models/page-template.model";

export const PAGE_TEMPLATE = new InjectionToken<PageTemplate>('PageTemplate');